export const ROLES = [
  {
		id: 88,
		name: 'Alumno',
    description: 'Alumno',
    active: true
	},
  {
		id: 87,
		name: 'Profesor',
    description: 'Profesor Valladolid',
    active: true
	},
  // {
	// 	id: 92,
	// 	name: 'Profesor Preescolar',
  //   description: '',
  //   active: false
	// },
  // {
	// 	id: 93,
	// 	name: 'Profesor Primaria',
  //   description: '',
  //   active: false
	// },
];